




























import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator';
import { Brand, BrandIndexItem, BrandQueryResultItem } from '@/api/braendz';
import { BusyObject } from '@/models/Busy';

import VerticalBrandTile from './VerticalBrandTile.vue';

// Type definitions for better readability
type BrandType = BrandQueryResultItem | BrandIndexItem | Brand;
type BusyBrandType = BusyObject<BrandQueryResultItem> | BusyObject<BrandIndexItem> | BusyObject<Brand>;
type BrandOrBusyType = BrandType | BusyBrandType;

@Component({
    components: {
        VerticalBrandTile
    }
})
export default class VerticalBrandTileGrid extends Vue {
    // Type guards for BusyObject
    public isBusyObject = (b: BrandOrBusyType): b is BusyBrandType => {
        return (b as BusyBrandType)?.object !== undefined || (b as BusyBrandType)?.isBusy !== undefined;
    }

    // Type guards for brand types (works with both direct brands and BusyObject brands)
    public isBrandQueryResultItem = (b: BrandType): b is BrandQueryResultItem => {
        return (b as BrandQueryResultItem)?.indexItem !== undefined;
    }
    public isBrandIndexItem = (b: BrandType): b is BrandIndexItem => {
        return (b as BrandIndexItem)?.brandId !== undefined;
    }
    public isBrand = (b: BrandType): b is Brand => {
        return !this.isBrandQueryResultItem(b) && !this.isBrandIndexItem(b);
    }

    // Component Properties:
    @Prop({ required: true })
    public brands!: BrandOrBusyType[];

    @Prop({ required: false, default: true, type: Boolean })
    public showCommon!: boolean;

    @Prop({ required: false, default: true, type: Boolean })
    public showDates!: boolean;

    @Prop({ required: false, default: true, type: Boolean })
    public showOwner!: boolean;

    @Prop({ required: false, default: true, type: Boolean })
    public showNiceClasses!: boolean;

    @Prop({ required: false, default: false, type: Boolean })
    public showGoodsServices!: boolean;

    @Prop({ required: false, default: true, type: Boolean })
    public showViennaClasses!: boolean;

    @Prop({ required: false, default: "3" })
    public xl!: string;

    @Prop({ required: false, default: "4" })
    public lg!: string;

    @Prop({ required: false, default: "6" })
    public md!: string;

    @Prop({ required: false, default: "6" })
    public sm!: string;

    @Prop({ required: false, default: "12" })
    public xs!: string;

    // Methods:
    public getBrandObject(item: BrandOrBusyType): BrandType | null | undefined {
        if (this.isBusyObject(item)) {
            return item.object;
        }
        return item;
    }

    public getIdOrIndex(item: BrandOrBusyType | null | undefined, index: number) {
        if(item) {
            const brand = this.getBrandObject(item);
            if(brand) {
                if(this.isBrandQueryResultItem(brand)) return brand.indexItem?.id ?? brand.indexItem?.brandId ?? index;
                if(this.isBrandIndexItem(brand)) return brand.id ?? brand.brandId ?? index;
                if(this.isBrand(brand)) return brand.id ?? index;
            }
        }
        return index;
    }
}
